<template>
    <div id="mailType3">
        <div class=startingEndPoint>
            <StartingEndPoint/>
        </div>
        <BoxList/>
        <div class="size">
            <Size boxType="03"/>
        </div>
    </div>
</template>

<script>
// 引人组件
import StartingEndPoint from "@/components/StartingEndPoint"
import Size from "@/components/Size"
import BoxList from "@/views/Mail/BoxList/BoxList"
import {mapState,mapMutations} from 'vuex'
export default {
    mame:'',
    components:{
        StartingEndPoint,
        Size,
        BoxList
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {
        ...mapMutations(["INCREMENTLETTERNUM","DECREMENTLETTERNUM"])
    },
    computed:{
        // 映射状态
        ...mapState({"letterNum":state=>state.mail.letterNum})
    }
}
</script>

<style lang="less" scoped>
 .size{
     margin-top: 70px;
 }
/* 最大宽度768px 手机 */
@media screen and (max-width: 768px){

}
</style>